import React from 'react';
import { motion } from 'framer-motion';
import { FaUser } from 'react-icons/fa';

const teamMembers = [
  {
    title: 'Direction Générale',
    role: 'Leadership et vision stratégique'
  },
  {
    title: 'Service Commercial',
    role: 'Relation client et développement'
  },
  {
    title: 'Service Technique',
    role: 'Expertise et solutions'
  },
  {
    title: 'Service Administratif',
    role: 'Gestion et coordination'
  }
];

const Team = () => {
  return (
    <section id="team" className="team">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Notre Équipe</h2>
          <p>Des professionnels passionnés à votre service</p>
        </motion.div>
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              className="team-member"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="member-photo">
                <FaUser />
              </div>
              <h3>{member.title}</h3>
              <p>{member.role}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
